exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!ag-grid-community/styles/ag-grid.css"), "");
exports.i(require("-!../../../node_modules/css-loader/index.js!ag-grid-community/styles/ag-theme-material.css"), "");

// module
exports.push([module.id, ".ag-theme-material{--ag-header-foreground-color:#000;--ag-font-size:15px;--ag-material-accent-color:#522687;--ag-range-selection-border-color:rgba(82,38,135,.32)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20011b02","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/tableAg.vue
// module id = 574
// module chunks = 2